
import exp from 'constants';
import { lazy } from 'react';
import WidgetCategory from '../../WidgetCategory';


export default class BBDCheckboxTreeDescriptor  {
 
  static getDescription() {
    return {
      name: 'Checkboxtree (BBCheckboxTree)',
      component: lazy(() =>  import('./BBCheckboxTree')),
      label: 'BBCheckboxTree',
      category: WidgetCategory.experimental,
      variables: [
        
        {
          name: 'query',
          type: 'yasgui',
          label:'to fill the tree.   ?uri ?text ?parent ?icon ',
        },
       
      ],
    }
  }

  
}
